<template>
    <div>
        <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
        >
            <template v-slot:activator="{ on, attrs }">
                <ValidationProvider v-slot="{ errors }" :name="label" :rules="rules">
                    <v-text-field
                        v-model="dateFormatted"
                        v-bind:label="label"
                        v-bind:placeholder="placeholder"
                        v-bind:disabled="disabled"
                        v-bind:outlined="outlined"
                        v-bind:readonly="readonly"
                        v-mask="'##/##/####'"
                        v-bind="attrs"
                        :error-messages="errors"
                        @change="date = parseDate(dateFormatted)"
                        v-on="on"
                    ></v-text-field>
                </ValidationProvider>
            </template>
            <v-date-picker
                v-model="date"
                @input="menu = false"
                locale="es-MX"
            ></v-date-picker>
        </v-menu>
     </div>                   
</template>
<script>
import { ValidationProvider } from "vee-validate";
export default {
    components: {
        ValidationProvider,
    },
    props:{
        rules: {
            type: [Object, String],
            default: ''
        },
        label: {
            type: String,
            default: ""
        },
        placeholder: {
            type: String,
            default: undefined
        },
        outlined: {
            type: Boolean,
            default: false
        },
        error: {
            type: Boolean,
            default: false
        },
        readonly: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        valorDefecto:{
            type:String,
            default:undefined
        },
    },
    data: vm => ({
        date: null,
        dateFormatted: null,
        menu: false,
    }),
    watch: {
        date (val) {
            this.dateFormatted = this.formatDate(this.date);
            this.$emit("input",  this.date)
        },
        valorDefecto(val){
            this.date = val;
        }
    },
    methods: {
        formatDate (date) {
            if (!date) return null
            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
        parseDate (date) {
            if (!date) return null
            const [day, month, year] = date.split('/')
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },
        setDate(date){
          this.date = date;
        },
        resetDate(){
          this.date = null;
          this.dateFormatted = null;
        }
    },
    mounted() {
        this.date = this.valorDefecto;
    },
    
};
</script>